import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-agents-row',
  templateUrl: './agents-row.component.html',
  styleUrls: ['./agents-row.component.scss'],
})
export class AgentsRowComponent implements OnInit {
  @Input() agent: any;
  @Output() checkAgent: EventEmitter<any> = new EventEmitter<any>();

  arrayConstants: any = [];
  cuitWithFormat: string = '';

  ngOnInit(): void {
    this.arrayConstants['TEAM_JUNIOR'] = 'Team member';
    this.arrayConstants['RAPP'] = 'Rapp';
    this.arrayConstants['ALTO'] = 'Alto';
    this.arrayConstants['PURO'] = 'Puro';
    this.arrayConstants['tipo'] = [];
    this.arrayConstants['tipo']['1'] = 'Responsable Inscripto';
    this.arrayConstants['tipo']['5'] = 'Consumidor Final';
    this.arrayConstants['tipo']['6'] = 'Monotributista';
    this.arrayConstants['factura'] = [];
    this.arrayConstants['factura']['1'] = 'A';
    this.arrayConstants['factura']['6'] = 'B';

    if (this.agent?.cuit) {
      this.cuitWithFormat = this.formatCuit(this.agent.cuit);
    }
  }

  formatCuit(cuit: string) {
    const FIRST = cuit.slice(0, 2);
    const MIDDLE = cuit.slice(2, cuit.length - 1);
    const LAST = cuit.slice(-1);
    return FIRST + '-' + MIDDLE + '-' + LAST;
  }

  onCheckboxChange(event: boolean) {
    this.agent.checked = event;

    const DTO = {
      checked: event,
      id: this.agent.id,
    };
    this.checkAgent.emit(DTO);
  }
}
